<template>
  <div :data-clazz="model.clazz">
    <div class="panelTitle">{{ i18n['userTask'] }}</div>
    <div class="panelBody">
      <DefaultDetail :model="model" :on-change="onChange" :read-only="readOnly" />
      <div class="panelRow">
        <div>之后任务：</div>
        <a-select
          :disabled="readOnly"
          :filterOption="true"
          :value="model.task"
          @change="(e) => onChange('task', e)"
          placeholder="选择任务"
          style="width:90%; font-size:12px"
        >
          <a-select-option
            :key="taskIndex"
            :title="taskValue.name"
            :value="taskValue.full_name"
            v-for="(taskValue, taskIndex) in tasks"
          />
        </a-select>
      </div>
      <div class="panelRow">
        <div>
          <span style="color: red">*</span>
          {{ i18n['userTask.assignType'] }}：
        </div>
        <a-select
          :disabled="readOnly"
          :placeholder="i18n['userTask.assignType.placeholder']"
          :value="model.assignType"
          @change="(e) => { onChange('assignValue', []); onChange('assignType', e); assignmentType() }"
          style="width:90%; font-size: 12px"
        >
          <a-select-option key="person" value="person">{{i18n['userTask.assignType.person']}}</a-select-option>
          <a-select-option key="role" value="role">{{i18n['userTask.assignType.role']}}</a-select-option>
          <!-- <a-select-option key="persongroup" value="persongroup" :title="i18n['userTask.assignType.persongroup']" /> -->
          <a-select-option
            :title="i18n['userTask.assignType.department']"
            key="department"
            value="department"
          >{{i18n['userTask.assignType.department']}}</a-select-option>
          <a-select-option key="variable" value="variable">{{i18n['userTask.assignType.variable']}}</a-select-option>
        </a-select>
      </div>
      <div class="panelRow" v-if="model.assignType === 'person'">
        <div>
          <span style="color: red">*</span>
          {{ i18n['userTask.assignType.person.title'] }}：
        </div>
        <a-select
          :disabled="readOnly"
          :filterOption="true"
          :placeholder="i18n['userTask.assignType.person.placeholder']"
          :value="model.assignValue"
          @change="(e) => { onChange('assignValue', e); getPersons(e) }"
          style="width:90%; font-size:12px"
        >
          <a-select-option :key="user.id" :value="user.id" v-for="user in users">{{user.username}}</a-select-option>
        </a-select>
      </div>
      <div class="panelRow" v-else-if="model.assignType === 'role'">
        <div>
          <span style="color: red">*</span>
          {{ i18n['userTask.assignType.role.title'] }}：
        </div>
        <a-select
          :disabled="readOnly"
          :placeholder="i18n['userTask.assignType.role.placeholder']"
          @change="(e) => { onChange('assignValue', e); getPersons(e) }"
          mode="multiple"
          style="width:90%; font-size:12px"
          v-model.number="model.assignValue"
        >
          <a-select-option :key="index" :value="item.id" v-for="(item, index) in roles">{{item.roleName}}</a-select-option>
        </a-select>
      </div>
      <div class="panelRow" v-else-if="model.assignType === 'persongroup'">
        <div>{{ i18n['userTask.assignType.persongroup.title'] }}：</div>
        <a-select
          :disabled="readOnly"
          :filterOption="true"
          :placeholder="i18n['userTask.assignType.persongroup.placeholder']"
          :value="model.assignValue"
          @change="(e) => { onChange('assignValue', e); getPersons(e) }"
          mode="multiple"
          style="width:90%; font-size:12px"
        >
          <a-select-option
            :key="group.id"
            :title="group.nickname===''?group.name:group.nickname"
            :value="group.id"
            v-for="group in groups"
          />
        </a-select>
      </div>
      <div class="panelRow" v-else-if="model.assignType === 'department'">
        <div>
          <span style="color: red">*</span>
          {{ i18n['userTask.assignType.department.title'] }}：
        </div>
        <a-select
          :disabled="readOnly"
          :filterOption="true"
          :placeholder="i18n['userTask.assignType.department.placeholder']"
          :value="model.assignValue"
          @change="(e) => { onChange('assignValue', e); getPersons(e) }"
          style="width:90%; font-size:12px"
        >
          <a-select-option
            :key="department.id"
            :value="department.id"
            v-for="department in departments"
          >{{department.tenantId}}-{{department.departName}}</a-select-option>
        </a-select>
      </div>
      <div class="panelRow" v-else-if="model.assignType === 'variable'">
        <div>
          <span style="color: red">*</span>
          {{ i18n['userTask.assignType.variable.title'] }}：
        </div>
        <a-select
          :disabled="readOnly"
          :filterOption="true"
          :placeholder="i18n['userTask.assignType.variable.placeholder']"
          @change="(e) => { onChange('assignValue', e); getPersons(e) }"
          style="width:90%; font-size:12px"
          v-model.number="model.assignValue"
        >
          <a-select-option :key="index" :value="item.value" v-for="(item, index) in variableOptions">{{item.label}}</a-select-option>
        </a-select>
      </div>
      <div class="panelRow">
        <a-checkbox
          :checked="model.isCounterSign"
          :disabled="model.assignType !== 'role' && model.assignType !== 'department' && (
            model.assignValue===undefined ||
            model.assignValue===null ||
            model.assignValue.length <= 1 ||
            model.activeOrder ||
            readOnly)"
          @input="(e) => { onChange('isCounterSign', e); initCounterSign(e) }"
        >会签</a-checkbox>
        <a-checkbox
          :checked="model.activeOrder"
          :disabled="
            model.assignValue===undefined||
              model.assignValue===null||
              model.assignValue.length <= 1||
              model.isCounterSign||
              readOnly"
          @input="(value) => onChange('activeOrder', value)"
          size="small"
        >主动接单</a-checkbox>
        <a-checkbox
          :value="model.fullHandle"
          @input="(value) => onChange('fullHandle', value)"
          v-if="(model.assignType === 'role' || model.assignType === 'department') &&
            model.assignValue!==undefined &&
            model.assignValue!==null &&
            model.assignValue.length >= 1 &&
            model.isCounterSign"
        >全员处理</a-checkbox>
      </div>

      <NodeDetail
        :model="model"
        :on-change="onChange"
        :read-only="readOnly"
        :readonly-preview="false"
        :templates="templates"
        :templates-base="templatesBase"
        :users="users"
      />
    </div>
  </div>
</template>
<script>
  import DefaultDetail from './DefaultDetail'
  import NodeDetail from './NodeDetail'
  export default {
    name: 'UserTaskDetail',
    inject: ['i18n'],
    components: {
      DefaultDetail,
      NodeDetail
    },
    props: {
      model: {
        type: Object,
        default: () => { }
      },
      users: {
        type: Array,
        default: () => []
      },
      roles: {
        type: Array,
        default: () => []
      },
      groups: {
        type: Array,
        default: () => []
      },
      departments: {
        type: Array,
        default: () => []
      },
      tasks: {
        type: Array,
        default: () => []
      },
      onChange: {
        type: Function,
        default: () => { }
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      templates: {
        type: Array,
        default: () => []
      },
      templatesBase: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        variableOptions: [{
          value: 1,
          label: '创建者'
        }, {
          value: 2,
          label: '创建者负责人'
        }],
        roleList: []
      }
    },
    methods: {
      getPersons (e) {
        if (e === undefined || e === null || e.length <= 1) {
          this.onChange('activeOrder', false)
          this.onChange('isCounterSign', false)
        }
      },
      initCounterSign (e) {
        if (!e) {
          this.onChange('fullHandle', false)
        }
      },
      assignmentType () {
        this.onChange('isCounterSign', false)
      }
    }
  }
</script>
